export const environment = {
    ENVIRONMENT: 'production',
    API_URL: 'https://apigw.unitedtowers.com/',
    NOTIFICATION_HUB_URL: 'https://hubs.utclub.eu/hubs/notification',
    CDN_URL: 'https://cdn.utclub.eu',
    OFFER_URL: 'https://offer.unitedtowers.com/',
    FORM_URL: 'https://form.unitedtowers.com/'
};
